var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-card',{staticClass:"mt-5 text-center",attrs:{"border-variant":"danger"}},[_c('b-card-title',[_vm._v("This page is restricted to authorized users")]),_c('b-link',{attrs:{"to":{ name: 'login', query: { from: this.$route.path } }}},[_vm._v("Sign In")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }